<template>
   <div class="base-dropdown">
      <select>
         <option
            v-for="opt in options"
            :key="opt.value"
            :value="opt.value"
            :selected="isSelected(opt)"
         >
            {{ opt.text }}
         </option>
      </select>

      <div class="placeholder">{{ placeholder }}</div>
      <div class="caret">
         <i class="fc_dropdown" />
      </div>
   </div>
</template>

<script>
export default {
   model: {
      prop: 'selectedOption',
      event: 'change',
   },

   props: {
      options: {
         type: Array,
         default: () => [],
      },

      selectedOption: {
         type: String,
         default: null,
      },

      placeholder: {
         type: String,
         default: null,
      },
   },

   data() {
      return {
         selectEl: null,
      };
   },

   watch: {
      options() {
         this.initSelectedOption();
      },
   },

   created() {
      this.initSelectedOption();
   },

   mounted() {
      this.selectElements();
      this.attachSelectChangeListener();
   },

   methods: {
      initSelectedOption() {
         let selectHit = false;

         if (this.selectedOption) {
            selectHit = this.options.some(opt => opt.value === this.selectedOption);
         }

         if (!selectHit && this.options.length) {
            this.$emit('change', this.options[0].value);
         }
      },

      selectElements() {
         this.selectEl = this.$el.querySelector('select');
      },

      isSelected(opt) {
         return opt.value === this.selectedOption;
      },

      attachSelectChangeListener() {
         this.selectEl.addEventListener('change', () => {
            const selectedIdx = this.selectEl.selectedIndex;
            const selectedVal = this.selectEl.options[selectedIdx].value;
            this.$emit('change', selectedVal);
         });
      },
   },
};
</script>

<style lang="scss" scoped>
.base-dropdown {
   display: inline-block;
   border: 1px solid rgba(62, 57, 107, 0.13);
   border-radius: 4px;
   position: relative;

   select {
      width: 100%;
      display: block;
      padding: 7px 35px 7px 10px;
      font-size: 14px;
      // font-weight: 600;
      border: none;
      background: transparent;
      -moz-appearance: none;
   }

   .placeholder {
      position: absolute;
      top: -10px;
      left: 7px;
      font-size: 12px;
      font-weight: 600;
      padding: 0px 3px;
      color: #9f9fb9;
      background: #fff;
      pointer-events: none;
   }

   .caret {
      position: absolute;
      top: 5px;
      right: 12px;
      pointer-events: none;

      i {
         font-size: 12px;
      }
   }
}
.chart-section-wrapper {
   .placeholder {
      background: #f9f9fb;
   }
   .themes {
      .placeholder {
         background: #ffffff;
      }
   }
}
// product gallery page(/fusioncharts)
.product-gallery-page {
   .base-dropdown {
      width: 100%;
   }
   .base-dropdown select {
      padding: 14px 35px 14px 10px;
   }
   .base-dropdown .caret {
      top: 13px;
   }
}
</style>
